export class Duplicacion {
    constructor(
        public id: number = 0,
        public fecha: string = "",
        public descripcion: string = "",
        public user_id: number = 0,
        public cobranza_id: number = 0,

        public cobranza: any[] = []
    ) {
    }
}